// ==========================================================================
// CACTUS KNIGHT — Mobile-Produktseite: Wisch-Galerie
// Nur auf Handys sichtbar (siehe product.css). Läuft auch auf Desktop mit,
// richtet dort aber nichts an, weil die zugehörigen Elemente per CSS
// display:none sind bzw. dort keine Scroll-Events auf dem Track ankommen.
// ==========================================================================

document.addEventListener("DOMContentLoaded", () => {
  const track = document.getElementById("mobile-gallery-track");
  const dots = document.querySelectorAll("#mobile-gallery-dots .mobile-gallery__dot");

  if (!track || dots.length === 0) return;

  let ticking = false;

  function updateActiveDot() {
    ticking = false;
    const slideWidth = track.clientWidth;
    if (!slideWidth) return;
    const index = Math.round(track.scrollLeft / slideWidth);
    dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
  }

  track.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateActiveDot);
      }
    },
    { passive: true }
  );

  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" });
    });
  });

  window.addEventListener("resize", updateActiveDot);

  // ---- Klick + Ziehen mit der Maus (Touch/Trackpad funktioniert nativ) ----
  // overflow-x:auto lässt sich per Touch oder Trackpad direkt wischen,
  // reagiert aber NICHT auf Ziehen mit gedrückter Maustaste — genau das
  // ist beim Testen im Desktop-Browser (Geräte-Symbolleiste) der übliche
  // Bedienweg, ohne dieses Nachrüsten passiert dort optisch gar nichts.
  let isDragging = false;
  let dragStartX = 0;
  let dragStartScroll = 0;
  let dragMoved = false;

  track.addEventListener("mousedown", (e) => {
    isDragging = true;
    dragMoved = false;
    dragStartX = e.pageX;
    dragStartScroll = track.scrollLeft;
    track.classList.add("is-dragging");
  });

  window.addEventListener("mousemove", (e) => {
    if (!isDragging) return;
    const delta = e.pageX - dragStartX;
    if (Math.abs(delta) > 3) dragMoved = true;
    track.scrollLeft = dragStartScroll - delta;
  });

  window.addEventListener("mouseup", () => {
    if (!isDragging) return;
    isDragging = false;
    track.classList.remove("is-dragging");
    updateActiveDot();
  });

  // Verhindert, dass ein Ziehen versehentlich als Klick auf das Bild zählt,
  // und öffnet bei einem echten Tipp die Lightbox — so kann auf dem Handy
  // dasselbe Zoom-/Vorschaufenster wie auf dem Desktop genutzt werden.
  track.addEventListener(
    "click",
    (e) => {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (typeof window.ckOpenLightbox === "function") {
        const slideWidth = track.clientWidth || 1;
        const index = Math.round(track.scrollLeft / slideWidth);
        window.ckOpenLightbox(index);
      }
    },
    true
  );
});
